import { apiJson } from './client';

export interface ProfCheckpointEncounter {
  id: string;
  questionId: string;
  questionText: string;
  expiresAt: string;
}

export interface ProfCheckpointResult {
  encounterId: string;
  studentAnswer: boolean;
  correctAnswer: boolean;
  correct: boolean;
  principleId: string;
  argomentoId: string;
  graded: true;
  completedAt: string;
}

export const profCheckpointApi = {
  issue(sessionId: string, messageId: string): Promise<{ encounter: ProfCheckpointEncounter }> {
    return apiJson('/api/prof/checkpoint/issue', {
      method: 'POST',
      body: JSON.stringify({ sessionId, messageId }),
    });
  },

  submit(
    encounterId: string,
    idempotencyKey: string,
    answer: boolean,
  ): Promise<{ result: ProfCheckpointResult }> {
    return apiJson('/api/prof/checkpoint/submit', {
      method: 'POST',
      body: JSON.stringify({ encounterId, idempotencyKey, answer }),
    });
  },
};
